import { ActionButton, Buttons, CancelButton, ModalCard } from '~/components';
import { useApi, useToast, useWorkspace } from '~/contexts';
import { useForm } from '~/hooks';
import React from 'react';

export default function LoadFromQuickBooksDialog({ creditNote, resolve }) {
  const { workspace } = useWorkspace();
  const [{ isSubmitting, saved }, form] = useForm();
  const toast = useToast();
  const api = useApi();

  const handleSubmit = async () => {
    form.submit();

    try {
      const { data } = await api.www.workspaces(workspace.id).creditNotes(creditNote.id).loadFromQuickBooks();
      await resolve(data);
      toast.success(`Credit Note #${data.creditNote.number} has been reloaded from QuickBooks.`);
    } catch (error) {
      toast.error(error.message ?? 'An error has occurred. The credit note has not been reloaded from QuickBooks.');
      form.done();
    }
  };

  return (
    <ModalCard title="Reload from QuickBooks" onClose={() => resolve(false)}>
      <ModalCard.Body>
        Are you sure you want to reload this credit note from QuickBooks? This will not load any payments that the
        QuickBooks Credit Memo is applied to.
      </ModalCard.Body>

      <ModalCard.Footer>
        <Buttons align="right">
          <CancelButton onClick={() => resolve(false)}>Cancel</CancelButton>
          <ActionButton isLoading={isSubmitting} ok={saved} onClick={handleSubmit}>
            Load
          </ActionButton>
        </Buttons>
      </ModalCard.Footer>
    </ModalCard>
  );
}
